import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import TodayPicks from '../components/layouts/explore-01/TodayPicks'
import todayPickData from '../assets/fake-data/data-today-pick'

const Explore01 = () => {
    return (
        <div>
            <Header />
            <TodayPicks data={todayPickData} />
            <Footer />
        </div>
    )
}

export default Explore01
